// @flow

import React from 'react';

import Help from './Help';
import Questions from './Questions';

import type { FormActions } from 'app/developer-v3/components/PartnerSupportForm/types';
import type { SelectedNode } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';
import type { States } from 'app/developer-v3/components/PartnerSupportForm/machine';

type Props = {
  nodes: SelectedNode[],
  actions: FormActions,
  state: States,
};

export const State = (props: Props) => {
  const { state } = props;

  if (state === 'help' || state === 'submitting' || state === 'submitted') {
    return <Help {...props} />;
  }

  return <Questions {...props} />;
};

export default State;
